<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 32h-1.25l-2.16-11.51A5.51 5.51 0 0033.18 16H25.5v-3H30a2 2 0 002-2V6a2 2 0 00-2-2H18a2 2 0 00-2 2v5a2 2 0 002 2h4.5v3h-7.68a5.51 5.51 0 00-5.41 4.49L7.25 32H6a2 2 0 00-2 2v8a2 2 0 002 2h36a2 2 0 002-2v-8a2 2 0 00-2-2zM19 7h10v3H19zm-6.64 14a2.51 2.51 0 012.46-2h18.36a2.51 2.51 0 012.46 2l2 11H10.31zM41 41H7v-6h34z"/><path d="M15.5 22h17v4h-17zM21.5 39h5a1 1 0 000-2h-5a1 1 0 000 2z"/></svg>